import { USERAUTH } from '../types/user';
// export const setBuildings = (data) => async dispatch => { dispatch({ type: BUILDINGS, payload: data })}
export const setAuthUser = (data) => ({ type: USERAUTH, payload: data });
